import { Phone, Mail, MapPin, Clock, Facebook, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Informações da Clínica */}
          <div>
            <div className="text-2xl font-bold gradient-primary bg-clip-text text-transparent mb-4">
              AYMEE Clínica Multidisciplinar
            </div>
            <p className="text-gray-300 mb-4">
              Cuidando da sua saúde mental e bem-estar com excelência e dedicação há mais de 10 anos.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-primary transition-smooth">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-primary transition-smooth">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-primary transition-smooth">
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Serviços */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Nossos Serviços</h3>
            <ul className="space-y-2 text-gray-300">
              <li>Psicologia</li>
              <li>Psicanálise</li>
              <li>Fonoaudiologia</li>
              <li>Avaliação Neuropsicológica</li>
              <li>Avaliação Psicopedagógica</li>
              <li>Laudos Médicos</li>
              <li>Reforço Escolar</li>
              <li>Atividades para Idosos</li>
            </ul>
          </div>

          {/* Contato */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contato</h3>
            <div className="space-y-3 text-gray-300">
              <div className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-primary" />
                <span>(11) 99999-0000</span>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-primary" />
                <span>contato@clinicaaymee.com</span>
              </div>
              <div className="flex items-center gap-2">
                <MapPin className="h-4 w-4 text-primary" />
                <span>Rua das Flores, 123<br />São Paulo, SP - 01234-567</span>
              </div>
            </div>
          </div>

          {/* Horários */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Horários</h3>
            <div className="space-y-2 text-gray-300">
              <div className="flex items-center gap-2">
                <Clock className="h-4 w-4 text-primary" />
                <div>
                  <div>Segunda a Sexta</div>
                  <div className="text-sm">8:00 às 18:00</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <Clock className="h-4 w-4 text-primary" />
                <div>
                  <div>Sábado</div>
                  <div className="text-sm">8:00 às 12:00</div>
                </div>
              </div>
              <div className="text-sm text-gray-400">
                Domingo: Fechado
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              © {currentYear} AYMEE Clínica Multidisciplinar. Todos os direitos reservados.
            </div>
            <div className="flex space-x-6 text-sm text-gray-400">
              <a href="#" className="hover:text-primary transition-smooth">
                Política de Privacidade
              </a>
              <a href="#" className="hover:text-primary transition-smooth">
                Termos de Uso
              </a>
              <a href="#" className="hover:text-primary transition-smooth">
                LGPD
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;